import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
// import { useState } from "react";


const RequirementForm = ({ service, onClose }) => {
    const [form, setForm] = useState({
        name: "",
        email: "",
        mobile: "",
        requirement: "",
        service: service || ""
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const validate = () => {
        let temp = {};
        if (!form.name) temp.name = "Name is required";
        if (!form.email) temp.email = "Email is required";
        if (!form.mobile) temp.mobile = "Mobile number is required";
        if (!form.requirement) temp.requirement = "Please describe your requirement";

        setErrors(temp);
        return Object.keys(temp).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        setLoading(true);

        try {
            const payload = {
                name: form.name,
                email: form.email,
                mobile: form.mobile,
                service: form.service,
                message: form.requirement,
            };

            console.log("📤 Sending Payload:", payload);

            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/aaj-engineer/requirement`,
                payload
            );

            console.log("📥 API Response:", response.data);

            if (response.data.status === "SUCCESS") {
                Swal.fire({
                    title: "Requirement Sent!",
                    text: response.data.message,
                    icon: "success",
                    confirmButtonText: "OK",
                });

                // Reset form
                setForm({
                    name: "",
                    email: "",
                    mobile: "",
                    requirement: "",
                    service: service || "",
                });

                onClose();
            } else {
                Swal.fire({
                    title: "Error",
                    text: response.data.message || "Something went wrong.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            console.error("❌ API Error:", error);

            Swal.fire({
                title: "Submission Failed!",
                text:
                    error.response?.data?.message ||
                    "Something went wrong. Please try again later.",
                icon: "error",
                confirmButtonText: "OK",
            });
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
            <div
                className="
      bg-gray-100 rounded-2xl shadow-2xl 
      w-full max-w-2xl
    
      max-h-[90vh] overflow-y-auto
    "
            >

                {/* ======== HEADER ======== */}
                <div className="
  flex justify-between items-center 
  bg-[#1f4fa3] 
  p-4 rounded-t-2xl
">
                    <h2 className="text-lg sm:text-xl font-bold text-white tracking-wider uppercase">
                        Share Your Requirement
                    </h2>

                    <button
                        onClick={onClose}
                        className="
      text-white text-xl font-bold 
      hover:text-gray-200
      transition-all duration-200
    "
                    >
                        ✕
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-5   p-5 sm:p-6 md:p-8">

                    {/* ROW 1 — NAME + EMAIL */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-semibold mb-1">Name</label>
                            <input
                                type="text"
                                placeholder="Your Name"
                                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
                                value={form.name}
                                onChange={(e) => setForm({ ...form, name: e.target.value })}
                            />
                            {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
                        </div>

                        <div>
                            <label className="block text-sm font-semibold mb-1">Email</label>
                            <input
                                type="email"
                                placeholder="Your Email"
                                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
                                value={form.email}
                                onChange={(e) => setForm({ ...form, email: e.target.value })}
                            />
                            {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                        </div>
                    </div>

                    {/* ROW 2 — MOBILE + SERVICE */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-semibold mb-1">Mobile</label>
                            <input
                                type="tel"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                placeholder="Mobile Number"
                                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
                                value={form.mobile}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        mobile: e.target.value.replace(/\D/g, "") 
                                    })
                                }
                            />

                            {errors.mobile && <p className="text-red-500 text-sm mt-1">{errors.mobile}</p>}
                        </div>

                        <div>
                            <label className="block text-sm font-semibold mb-1">Service</label>
                            <input
                                type="text"
                                className="w-full p-3 border rounded-lg bg-gray-200"
                                value={form.service}
                                readOnly
                            />
                        </div>
                    </div>

                    {/* FULL WIDTH — REQUIREMENT */}
                    <div>
                        <label className="block text-sm font-semibold mb-1">Message</label>
                        <textarea
                            placeholder="Describe your requirement..."
                            rows="4"
                            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
                            value={form.requirement}
                            onChange={(e) => setForm({ ...form, requirement: e.target.value })}
                        />
                        {errors.requirement && (
                            <p className="text-red-500 text-sm mt-1">{errors.requirement}</p>
                        )}
                    </div>

                    {/* SUBMIT */}
                    <button
                        type="submit"
                        disabled={loading}
                        className="block mx-auto w-[200px] py-3 bg-gradient-to-r from-[#011321] to-[#03365f] text-white font-semibold rounded-lg hover:scale-105 transition-all disabled:opacity-70"
                    >
                        {loading ? "Sending..." : "Submit Requirement"}
                    </button>


                </form>
            </div>
        </div>


    );
};

export default RequirementForm;
